import { useLoader } from 'one'
import { H2, Paragraph, Spacer, XStack } from '@hanzo/gui'
import { ContainerLarge } from '~/components/Containers'
import { Link } from '~/components/Link'
import { GuiCard } from '~/components/GuiCard'
import { authors } from '~/data/authors'
import { HeadInfo } from '~/components/HeadInfo'

export async function loader() {
  const { getAllFrontmatter } = await import('~/features/mdx/getMDXBySlug')
  const frontmatters = getAllFrontmatter('data/blog')
  const sortedFrontmatters = frontmatters
    .filter((x) => !x.draft)
    .sort(
      (a, b) =>
        Number(new Date(b.publishedAt || '')) - Number(new Date(a.publishedAt || ''))
    )
  return { frontmatters: sortedFrontmatters }
}

export default function Blog() {
  const { frontmatters } = useLoader(loader)

  return (
    <>
      <HeadInfo title="Blog — Gui" description="What's up with Gui." />
      <Spacer size="$7" />
      <ContainerLarge mb="$7">
        <H2 size="$8" color="$color9" fontFamily="$pixel">
          Blog
        </H2>
        <Spacer size="$6" />
        <XStack flexWrap="wrap" gap="$4" $md={{ flexDirection: 'column' }}>
          {frontmatters.map((frontmatter) => (
            <Link asChild key={frontmatter.title} href={`/blog/${frontmatter.slug}`}>
              <GuiCard
                title={frontmatter.title}
                render="a"
                width="calc(50% - var(--space-2))"
                minH="max-content"
                $md={{
                  width: '100%',
                  maxWidth: '100%',
                  flex: 'unset',
                  flexShrink: 0,
                }}
                $sm={{
                  width: '100%',
                  maxWidth: '100%',
                  flex: 'unset',
                  flexShrink: 0,
                }}
                subTitle={
                  <Paragraph opacity={0.5} cursor="inherit" color="$color10" size="$3">
                    {Intl.DateTimeFormat('en-US', {
                      month: 'short',
                      year: 'numeric',
                      day: 'numeric',
                    }).format(new Date(frontmatter.publishedAt || ''))}{' '}
                    by &nbsp;
                    {authors[frontmatter.by || '']?.name}
                  </Paragraph>
                }
              >
                {frontmatter.description}
              </GuiCard>
            </Link>
          ))}
        </XStack>
      </ContainerLarge>
    </>
  )
}
